import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    totalActiveStorage: string;
    totalArchivalStorage: string;
    totalMountedStorage: string;
    manageActiveStorage: string;
    manageArchivalStorage: string;
    manageMountedStorage: string;
    activeStorageType: string;
    archivalStorageType: string;
    mountedStorageType: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title for standard storage total display */
            totalActiveStorage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.totalActiveStorage?c=r473que2cslv", defaultMessage: "Total Standard Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for archival storage total display */
            totalArchivalStorage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.totalArchivalStorage?c=oykzw7zpy76j", defaultMessage: "Total Archival Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for mounted storage total display */
            totalMountedStorage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.totalMountedStorage?c=2nvaf6w8ah2pz", defaultMessage: "Total Mounted Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for managing standard storage */
            manageActiveStorage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.manageActiveStorage?c=21jyv9iahkzxm", defaultMessage: "Manage Standard Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for managing archival storage */
            manageArchivalStorage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.manageArchivalStorage?c=1544jtvsmvnqz", defaultMessage: "Manage Archival Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog title for managing mounted storage */
            manageMountedStorage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.manageMountedStorage?c=3jpy2w3y5ktua", defaultMessage: "Manage Mounted Storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Storage type label used in add-on action descriptions for active storage */
            activeStorageType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.activeStorageType?c=2qlhw1xzhoib8", defaultMessage: "storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Storage type label used in add-on action descriptions for archival storage */
            archivalStorageType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.archivalStorageType?c=7tk5b0667uvf", defaultMessage: "archival storage" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Storage type label used in add-on action descriptions for mounted storage */
            mountedStorageType: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "storageVariantConfig.mountedStorageType?c=b25hwfa0ztzy", defaultMessage: "mounted storage" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
